const translations = {
    es: {
        // Cabeceras de tabla
        "table.header.uuid": "UUID",
        "table.header.model": "Modelo",
        "table.header.config": "Configuración",
        "table.header.send": "Enviar",
        "table.header.mode": "Modo",
        "table.header.confirmations": "Confirmaciones",
        "table.header.date": "Fecha",
        "table.header.power": "Potencia",
        "table.header.alert": "Alerta",
        "table.header.updated": "Actualizado",
        "table.header.status": "Estado",
        "table.header.actual": "Actual",
        "table.header.queue": "Cola",

        // Tipos de envíos
        "send.type.measurement": "Medición",
        "send.type.sensors": "Sensores",
        "send.type.alerts": "Alarmas",

        // Confirmaciones
        "confirm.sent": "Enviado",
        "confirm.confirmed": "Confirmado",
        "confirm.sent.short": "E",
        "confirm.confirmed.short": "C",

        // Botones
        "button.edit": "Editar",
        "button.send": "Enviar",
        "button.cancel": "Cancelar",
        "button.accept": "Aceptar",

        // Estados
        "status.pending": "Pendiente",
        "status.sent": "Enviado",
        "status.confirmed": "Confirmado",
        "status.error": "Error",

        // Mensajes
        "message.success.title": "Operación exitosa",
        "message.success.sent": "Configuración enviada correctamente",
        "message.error.title": "Error en el envío",
        "message.error.text": "No se ha podido enviar la configuración",
        "message.confirm.title": "Confirmar envío",
        "message.confirm.text":
            "¿Está seguro de enviar la configuración a los dispositivos seleccionados?",

        // Filtros
        "filter.search": "Buscar",
        "filter.search.placeholder": "uuid, uid, dirección",
        "filter.select.option": "Seleccionar a filtrar",
        "filter.select.status": "Seleccionar Estado",
        "filter.select.device_group": "Seleccionar Grupo de dispositivo",
        "filter.select.asset_group": "Seleccionar contenedores",
        "filter.select.island": "Seleccionar Isla",
        "filter.select.model": "Seleccionar Modelo",
        "filter.select.config": "Seleccionar Configuración",

        "filter.label.status": "Estado",
        "filter.label.device_group": "Grupo dispositivo",
        "filter.label.asset_group": "Grupo contenedor",
        "filter.label.island": "Isla",
        "filter.label.model": "Modelo",
        "filter.label.config": "Configuración",

        // Otros
        "no.data": "Sin datos",

        // Formulario
        "form.title.select.config": "Seleccionar configuración",
        "label.uuid": "UUID",
        "label.profile.group": "Grupo de perfil",
        "option.select.config": "Seleccionar configuración",
        "label.model": "Modelo",
        "label.name": "Nombre",
        "label.description": "Descripción",
        "section.measures.shipments": "Medidas y Envíos",
        "label.send": "Enviar",
        "label.interval.type": "Tipo de Intervalo",
        "label.sending.hour": "Hora de envio UTC o localtime",
        "label.minutes.between.measures": "Minutos entre medidas",
        "label.number.to.send": "N. para enviar",
        "label.number.messages": "N. mensajes",
        "label.minutes.between.measures.fl": "Minutos entre medidas FL",
        "section.sensors": "Sensores",
        "label.power": "Potencia",
        "label.levels": "Niveles",
        "label.full": "Lleno",
        "label.empty": "Vacio",
        "label.email.empty": "Correo Vacio",
        "label.email.full": "Correo Lleno",
        "value.yes": "Si",
        "value.no": "No",
        "section.alerts": "Alertas",
        "label.movement": "Movimiento",
        "label.not.sending": "Sin enviar",
        "label.battery": "Bateria",
        "label.temperature": "Temperatura",
        "label.signal": "Señal",
        "label.out.of.location": "Fuera de localización",

        // Mensajes adicionales
        "message.warning.title": "Atención",
        "message.no.config.selected":
            "No se ha seleccionado ninguna configuración",
        "message.success.saved":
            "La configuración se ha guardado correctamente",
        "message.error.service": "Error en el servicio",
        "message.error.admin": "Avise al administrador",
        "message.error.server": "Error en el servidor",
        "message.error.bad.data": "Los datos enviados no son correctos",
        "message.error.configs": "Error al obtener las configuraciones",

        // Botones
        "button.save": "Guardar",
    },
    en: {
        // Table headers
        "table.header.uuid": "UUID",
        "table.header.model": "Model",
        "table.header.config": "Configuration",
        "table.header.send": "Send",
        "table.header.mode": "Mode",
        "table.header.confirmations": "Confirmations",
        "table.header.date": "Date",
        "table.header.power": "Power",
        "table.header.alert": "Alert",
        "table.header.updated": "Updated",
        "table.header.status": "Status",
        "table.header.actual": "Actual",
        "table.header.queue": "Queue",

        // Sending types
        "send.type.measurement": "Measurement",
        "send.type.sensors": "Sensors",
        "send.type.alerts": "Alerts",

        // Confirmations
        "confirm.sent": "Sent",
        "confirm.confirmed": "Confirmed",
        "confirm.sent.short": "S",
        "confirm.confirmed.short": "C",

        // Buttons
        "button.edit": "Edit",
        "button.send": "Send",
        "button.cancel": "Cancel",
        "button.accept": "Accept",

        // Statuses
        "status.pending": "Pending",
        "status.sent": "Sent",
        "status.confirmed": "Confirmed",
        "status.error": "Error",

        // Messages
        "message.success.title": "Successful operation",
        "message.success.sent": "Configuration sent successfully",
        "message.error.title": "Error in sending",
        "message.error.text": "The configuration could not be sent",
        "message.confirm.title": "Confirm sending",
        "message.confirm.text":
            "Are you sure to send the configuration to the selected devices?",

        // Filters
        "filter.search": "Search",
        "filter.search.placeholder": "uuid, uid, address",
        "filter.select.option": "Select to filter",
        "filter.select.status": "Select Status",
        "filter.select.device_group": "Select Device Group",
        "filter.select.asset_group": "Select Container Group",
        "filter.select.island": "Select Island",
        "filter.select.model": "Select Model",
        "filter.select.config": "Select Configuration",

        "filter.label.status": "Status",
        "filter.label.device_group": "Device Group",
        "filter.label.asset_group": "Container Group",
        "filter.label.island": "Island",
        "filter.label.model": "Model",
        "filter.label.config": "Configuration",

        // Others
        "no.data": "No data",

        // Form
        "form.title.select.config": "Select configuration",
        "label.uuid": "UUID",
        "label.profile.group": "Profile Group",
        "option.select.config": "Select configuration",
        "label.model": "Model",
        "label.name": "Name",
        "label.description": "Description",
        "section.measures.shipments": "Measurements & Shipments",
        "label.send": "Send",
        "label.interval.type": "Interval Type",
        "label.sending.hour": "UTC or localtime sending hour",
        "label.minutes.between.measures": "Minutes between measures",
        "label.number.to.send": "Number to send",
        "label.number.messages": "Number of messages",
        "label.minutes.between.measures.fl": "Minutes between FL measures",
        "section.sensors": "Sensors",
        "label.power": "Power",
        "label.levels": "Levels",
        "label.full": "Full",
        "label.empty": "Empty",
        "label.email.empty": "Email Empty",
        "label.email.full": "Email Full",
        "value.yes": "Yes",
        "value.no": "No",
        "section.alerts": "Alerts",
        "label.movement": "Movement",
        "label.not.sending": "Not sending",
        "label.battery": "Battery",
        "label.temperature": "Temperature",
        "label.signal": "Signal",
        "label.out.of.location": "Out of location",

        // Additional messages
        "message.warning.title": "Warning",
        "message.no.config.selected": "No configuration has been selected",
        "message.success.saved": "Configuration has been saved successfully",
        "message.error.service": "Service error",
        "message.error.admin": "Contact the administrator",
        "message.error.server": "Server error",
        "message.error.bad.data": "The data sent is not correct",
        "message.error.configs": "Error retrieving configurations",

        // Buttons
        "button.save": "Save",
    },
};

export default translations;
